import { useGlobalLoadingState } from '../context/GlobalLoadingStateContext';
import { useAppSelector } from '../reducers';
import { isAppReadySelector } from '../selectors/LoadingStateSelectors';
export const useGlobalLoading = () => {
  const isPurchaseOptionsLoading = useGlobalLoadingState('PurchaseOptions');
  return useAppSelector(isAppReadySelector({
    isPurchaseOptionsLoading
  }));
};